import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../constants/common'
import {
  DocFlowRequestLinksField,
  DocFlowTableName,
} from '../../constants/docFlow'
import { PAGINATION_ALL_ITEMS_VALUE } from '../../constants/pagination'
import { getPaginationApiParams } from '../../utils/pagination'

export const DocFlowPhaseItemStatus = {
  Combining: 2,
  Result: 4,
  Sending: 3,
  Splitting: 1,
  Uploading: 0,
}

export const DocFlowMappingType = {
  Multiplying: 0,
  Splitting: 1,
}

export const DocFlowWidgetStatus = {
  Completed: 2,
  InProgress: 1,
  NotStarted: 0,
  Skipped: 3,
}

export const DOC_FLOW_API_URL = '/api/document-stapling/document-staplings/'

// start profile form fields
export const DOC_FLOW_FORM_FIELD_TITLE = 'name'

export const DOC_FLOW_FORM_FIELD_FINAL_DOCUMENT_TITLE =
  'final_document_template_name'

export const DOC_FLOW_FORM_FIELD_VARIABLE = 'variable'

export const DOC_FLOW_FORM_FIELD_FILES = 'file_ids'

export const DOC_FLOW_FORM_FIELD_CONNECTED_REQUESTS = 'connectedRequests'

export const DOC_FLOW_FORM_FIELD_BUILDINGS = 'buildings'

export const DOC_FLOW_FORM_FIELD_BUILDING_GROUPS = 'building_groups'

export const DOC_FLOW_FORM_PAYLOAD_FIELD_BUILDING = 'building_id'

export const DOC_FLOW_FORM_PAYLOAD_FIELD_BUILDING_GROUP = 'building_group_id'

export const DOC_FLOW_BUILDING_OPTIONS_BUILDING_GROUP_PARAM = 'building_group'

export const DOC_FLOW_BUILDING_GROUP_OPTIONS_BUILDING_PARAM = 'building'

// The entity returns the scope as single option-shaped objects
// (`{ value, label: { title, avatar } }`) or null.
export const DOC_FLOW_ENTITY_FIELD_BUILDING = 'building'

export const DOC_FLOW_ENTITY_FIELD_BUILDING_GROUP = 'building_group'

export const DOC_FLOW_FORM_FIELD_APPLY_FINAL_NAME_CHECKBOX =
  'apply_template_to_custom_values'
// end profile form fields

// profile info items
export const DocFlowProfileHeaderInfoItemsFields = {
  BuildingGroups: DOC_FLOW_ENTITY_FIELD_BUILDING_GROUP,
  Buildings: DOC_FLOW_ENTITY_FIELD_BUILDING,
  ConnectedRequests: DocFlowRequestLinksField.DocFlowConnectedRequests,
  EpostSpentCredits: 'epost_spent_credits',
  FinalDocumentTitle: 'final_document_template_name',
  Status: 'status',
  UkEpostCredits: 'uk_epost_credits',
  UploadedDocuments: 'documents_count',
  Variable: 'variable',
}
// end profile info items

export const DOC_FLOW_MAX_FILES_NUMBER = 15

export const DOC_FLOW_PHASE_INFO_NOTIFICATION_UPLOADING = {
  text: 'DocumentStapling.UploadingPhaseInfoNotificationKey',
}

export const DOC_FLOW_PHASE_INFO_NOTIFICATION_SPLITTING = {
  text: 'DocumentStapling.SplittingPhaseInfoNotificationKey',
}

export const DOC_FLOW_PHASE_WARNING_SCANNED_NOTIFICATION_SPLITTING = {
  text: 'DocumentStapling.SplittingPhaseSplittingAndMappingWidgetWarningNotificationKey',
  type: NOTIFICATION_TYPE.warning,
}

export const DOC_FLOW_PHASE_INFO_NOTIFICATION_COMBINING = {
  text: 'DocumentStapling.CombiningPhaseInfoNotificationKey',
}

export const DOC_FLOW_PHASE_INFO_NOTIFICATIONS_SENDING = {
  text: 'DocumentStapling.SendingPhaseInfoNotificationKey',
}

export const DOC_FLOW_PHASE_INFO_NOTIFICATION_RESULT = {
  text: 'DocumentStapling.ResultPhaseInfoNotificationKey',
}

//uploading phase
export const DOC_FLOW_UPLOADING_ACTION_DELETE = 'delete_item'

export const DOC_FLOW_UPLOADING_ACTION_CHANGE_TYPE = 'change_type_item'

export const DOC_FLOW_UPLOADING_MASS_ACTION_DELETE = 'mass_delete_item'

export const DOC_FLOW_UPLOADING_MASS_ACTION_CHANGE_TYPE = 'update_type'

export const DOC_FLOW_FORM_TITLE_FIELD_MAX_LENGTH = 256

export const DOC_FLOW_FORM_FINAL_NAME_FIELD_MAX_LENGTH = 256

export const DOC_FLOW_FILE_ADDITIONAL_INFO_TOOLTIP =
  'DocumentStapling.UploadingTableTitleAdditionalInfoTooltipTextKey'

export const DOC_FLOW_TABLE_ACTIONS_COLUMN_WIDTH = 0

export const DOC_FLOW_UPLOADING_LIST_FILTERS_ALL = {
  ...getPaginationApiParams(PAGINATION_ALL_ITEMS_VALUE),
  filters: {},
  ordering: EMPTY_LIST,
}

export const DOC_FLOW_ACTIVE_PHASE_BY_COPING_FILTER = {
  [DocFlowTableName.Combining]: DocFlowPhaseItemStatus.Combining,
  [DocFlowTableName.Result]: DocFlowPhaseItemStatus.Result,
  [DocFlowTableName.Sending]: DocFlowPhaseItemStatus.Sending,
}

export const DOC_FLOW_FORM_FIELD_TYPE = 'type'

export const DOC_FLOW_PDF_PAGES_LIMIT = 5000

export const DOC_FLOW_SCREEN_WIDTH_HIDE_TABLE_CONTROL_BAR_TEXT = 1100 //px
